export default __webpack_public_path__ + "static/img-what-is-ml-425d75ee0e9e7bbf994ead9b1df11386.png";